import React from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faFax, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';


export const Footer = () => {
  const scrollToTop = () => {
    // Use the react-scroll scrollToTop function
    ScrollLink.scrollToTop();
  };

  return (
    <footer>
    <div className="container">
      <div className="row py-5">
        <div className="col-lg-3 col-md-9 col-12">
           <div className='logo mb-3'>
           <img src="images/logo.png" alt="logo" />

           </div>
          <p className='f-16'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p>
        </div>

        <div className="col-lg-3 col-md-4 col-6">
           <p className='fw-700'>QUICK LINKS</p>
          <ul className="list-unstyled mb-0 ">
            <li className="pb-2">
            <Link to="/" onClick={scrollToTop}>Home</Link>
             
            </li>
            <li className="pb-2">
            <Link to="/faq" onClick={scrollToTop}>Faq's</Link>
            </li>
            <li className="pb-2">
            <Link to="/customerservice" onClick={scrollToTop}>Customer Services</Link>
            </li>
            <li className="pb-2">
            <Link to="/contact" onClick={scrollToTop}>Contact Us</Link>
            </li>
          </ul>
        </div>

        <div className="col-lg-3 col-md-4 col-6">
            <p className='fw-700'>INFORMATION</p>
          <ul className="list-unstyled mb-0 ">
            <li className="pb-2">
            <Link to="/about" onClick={scrollToTop}>About Us</Link>
            </li>
            <li className="pb-2">
            <Link to="/contact" onClick={scrollToTop}>Contact Us</Link>
            </li>
            <li className="pb-2">
            <Link to="/sizing" onClick={scrollToTop}>Sizing Guide</Link>
            </li>
            <li className="pb-2">
            <Link to="/customerservice" onClick={scrollToTop}>Customer Services</Link>
            </li>
          </ul>
        </div>

        <div className="col-lg-3 py-5 py-md-5 py-lg-0">
        <p className='fw-700'>CONTACT US</p>
          <ul className="list-unstyled">
            <li className="pb-2">
                <a href="https://goo.gl/maps/ERQT2Fc9bTpVvqe38" className="d-flex align-items-center" target="_blank"><FontAwesomeIcon className="me-2" icon={faLocationDot} /> <span className='ms-1 f-18'>Location: 2750 Quadra Street
               Victoria, Canada </span></a>
            </li>
            <li className="pb-2">
              <a href="tel:(+123) 456-7898" className="d-flex align-items-center">
                <FontAwesomeIcon
                  className="me-2"
                  icon={faPhone}
                />
              <span className='f-18'>Call Us: (+123) 456-7898</span>
              </a>
            </li>
            <li className="pb-2">
              <a href="mailto:support@novine.com" className="d-flex align-items-center text-nowrap">
                <FontAwesomeIcon
                  className="me-2"
                  icon={faEnvelope}
                />
             <span className='f-18'>Email Us: support@novine.com</span>
              </a>
            </li>
            
            <li className="pb-2">
              <a href="#">
                <FontAwesomeIcon
                  className="me-2"
                  icon={faFax}
                />
             <span className='f-18'>Fax: +123456</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className='row align-items-center'>
        <div className='col-lg-9'>
         <p>&copy; 2023 React App Developed by Muhammad Anas </p> 
        </div>

        <div className='col-lg-3'>
          <ul className='list-unstyled d-flex'>
            <li> <img src='images/visa.png' /> </li>
            <li> <img src='images/mastercard.png' /> </li>
            <li> <img src='images/mastercard2.png' /> </li>
            <li> <img src='images/visa2.png' /> </li>
            <li> <img src='images/expresscard.png' /> </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
  )
}